import { Box } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

export function NotificationIcon({ variant = 'success' }: { variant?: 'success' | 'error' }) {
  const Icon = variant === 'success' ? IconCheck : IconX;
  return (
    <Box style={getStyleProps(variant)} data-testid="notification-icon">
      <Icon size={12} color="black" />
    </Box>
  );
}

function getStyleProps(variant: 'success' | 'error') {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `4px solid var(--mantine-color-${variant}-1)`,
    width: '100%',
    height: '100%',
    borderRadius: '100%',
    backgroundColor: `var(--mantine-color-${variant}-4)`,
    borderColor: `var(--mantine-color-${variant}-1)`,
  };
}
